import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import contactFormFile from "../../../assets/markDownFiles/contact/submission-form.md";

const ContactSubmissionForm = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (typeof contactFormFile === "string" && contactFormFile.startsWith("/static")) {
       fetch(contactFormFile)
      .then((res) => res.text())
      .then((raw) => {
        console.log(JSON.stringify(raw.slice(0, 200))); 
        setContent(convertMdxToMd(raw));
      });
         
    } else {
      console.log(JSON.stringify(contactFormFile.slice(0, 200)));
      setContent(convertMdxToMd(contactFormFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        Contact Us
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default ContactSubmissionForm;

